import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { PlanIntervals } from 'src/constants/planData'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { promoCodes } from 'src/constants/promoCodes'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'

export default (props) => {
  const posterImg = useEPLImage()

  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      poster={posterImg}
      noVideo={true}
      offerCode={promoCodes.canada_ftf_canada}
      offerBanner={{
        title: [
          'Special offer for FTF Canada members activated!',
          'Enjoy $30 off 3 months of live Premier League soccer & more.',
        ],
      }}
      title="Watch the Premier League all season"
      subtitle="Unlock your $30 discount now!"
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-ftf-canada_v1.png?ch=width&auto=format,compress"
      logoHeight="90px"
      forceAnchorLink={false}
      planCardsConfig={{
        plans: [canadaPlanData.ftf_offer],
        activeTab: PlanIntervals.quarterly,
        hideTabs: true,
      }}
      noIndex={true}
    />
  )
}
